import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function CollaborativeDocs({ attributes, docSections, articlesNumber, multiDocs }) {
    const { col, readMoreText, docs_layout, isFeaturedImage } = attributes;
    const [activeTab, setActiveTab] = useState(null);

    // Fetch all docs
    const allDocs = useSelect(
        (select) =>
            select("core").getEntityRecords("postType", "docs", {
                per_page: -1,
                status: ["publish", "private"],
            }),
        []
    );

    // Fetch all authors with their avatars
    const authors = useSelect(
        (select) => {
            const users = select("core").getEntityRecords("root", "user", { per_page: -1 });
            if (!users) return null;
            return users.reduce((acc, user) => {
                acc[user.id] = {
                    name: user.name,
                    avatar: user.avatar_urls?.["96"] || "", // Ensure correct key
                };
                return acc;
            }, {});
        },
        []
    );
    
    useEffect(() => {
        if (docSections && docSections.length > 0) {
            setActiveTab(docSections[0].id);
        } else if (multiDocs && multiDocs.length > 0) {
            setActiveTab(multiDocs[0].id);
        }
    }, [docSections, multiDocs]);

    if (!allDocs) return <p>Loading...</p>;
    if (allDocs.length === 0) return <p>No documents found.</p>;

    // Recursively count all child items for a parent doc
    const countAllChildDocs = (parentId) => {
        const directChildren = allDocs.filter((doc) => doc.parent === parentId);
        return directChildren.reduce(
            (count, child) => count + 1 + countAllChildDocs(child.id),
            0
        );
    };

    // Function to trim words
    const showWords = (sentence, numberOfWords) => {
        const wordsArray = sentence.replace(/<\/?[^>]+(>|$)/g, "").split(" "); // Strip HTML tags
        return numberOfWords >= wordsArray.length
            ? sentence
            : wordsArray.slice(0, numberOfWords).join(" ");
    };

    function FeaturedImage({ mediaId, title }) {
        const [imageUrls, setImageUrl] = useState("");

        useEffect(() => {
            if (mediaId) {
                wp.apiFetch({ path: `/wp/v2/media/${mediaId}` })
                    .then((media) => setImageUrl(media.source_url))
                    .catch((error) => console.error("Error fetching media:", error));
            }
        }, [mediaId]);

        return imageUrls ? <img src={imageUrls} /> : null;
    }

    return (
        <>
        <section className="doc6_community_area docs6 bew-topics">
            <div className="doc_community_info">
                {(docSections || multiDocs) &&
                    [...(docSections || []), ...(multiDocs || [])].map((section) => {
                        const totalChildDocs = countAllChildDocs(section.id);
                        const { id, featured_media } = section;   
                        // Fetch author data
                        const authorData = authors?.[section.author];

                        return (
                            <div className="doc_community_item topic-item wow fadeInUp" data-wow-delay="0.1s" key={section.id}>

                                <div className="doc_community_icon ezd-docs5-icon-wrap">
                                    {isFeaturedImage && (
                                        <FeaturedImage mediaId={featured_media}  />
                                    )}
                                </div>

                                <div className="doc_entry_content">
                                    <a href={section.link}>
                                        <h4 className="ezd_item_title">{section.title.rendered}</h4>
                                    </a>
                                    <p className="ezd_item_content">
                                        {showWords(section.excerpt.rendered, 15)}
                                    </p>
                                    <div className="doc_entry_info">
                                        <ul className="ezd-list-unstyled author_avatar">
                                            <li>
                                                {authorData?.avatar ? (
                                                    <img
                                                        src={authorData.avatar}
                                                        alt={authorData.name}
                                                    />
                                                ) : (
                                                    <img
                                                        src="https://www.gravatar.com/avatar/?d=mp"
                                                        alt="Default Avatar"
                                                    />
                                                )}
                                            </li>
                                            <li class="avatar_plus">+1</li>
                                        </ul>
                                        <div className="text">
                                            {totalChildDocs} Articles in this Doc. <br />
                                            Written by {authorData?.name} and others
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </section>
        </>
    );
}